// extracted by mini-css-extract-plugin
export default {"box":"VZKjvbQWmYwXz8NGwqZA","textBox":"CfSwPX397CY9D327eYfV","buttonBox":"vtUYzzunUxG88fWKXgh4"};